export default __webpack_public_path__ + "static/media/linkIcon.43e03c7e.svg";